import { useQuery } from '@tanstack/react-query';
import { fetchProductDetail, type ProductDetailResponse } from '../lib/api';

/**
 * Hook for fetching full product details by ID
 *
 * Uses React Query for caching and automatic refetching.
 * Disabled when productId is null/undefined.
 */
export function useProductDetail(productId: string | null | undefined) {
  const {
    data,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<ProductDetailResponse, Error>({
    queryKey: ['product-detail', productId],
    queryFn: () => fetchProductDetail(productId!),
    enabled: !!productId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    product: data?.product ?? null,
    isLoading,
    isError,
    error,
    refetch,
  };
}
